module.exports = __webpack_public_path__ + "img/bnisyariah.75168ade.png";